(function () {
  'use strict';

  angular
      .module('tfc.Products')
      .controller('ProdFilesCtrl', ProdFilesCtrl);

  // @ngInject
  function ProdFilesCtrl(ProductMgr, dateUtil, $stateParams) {
    var vm = this;

    vm.recentFilesDataFn = function (lastIdentifier) {
      return ProductMgr.findFiles(lastIdentifier, $stateParams.brandKey);
    };

    vm.options = {
      columnDefs: [
        {name: 'File Name', field: 'name', cellTooltip: true, headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'},
        {name: 'Uploaded By', field: 'email', cellTooltip: true, headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'},
        {name: 'Date', field: 'date', headerCellClass: 'ui-grid-header-custom', cellClass: 'ui-grid-cell-custom'}
      ],
      infiniteScrollRowsFromEnd: 40,
      pageSize: 100
    };

    vm.getFileId =  function(gridData, index) {
      if(gridData && gridData.length){
        return {
          'file-key': gridData[index].fileId
        }
      }
    };

    vm.formatRecentFilesData = function(files) {
      if(files && files.length)
      {
        return _.forEach(files, function (data) {
          _.assign(data, {'date': dateUtil.formatJsonDate(data.date, 'dd/MM/yyyy HH:mm:ss')})
        });
      }
      else
      {
        return [];
      }
    };
  }

})();
